module.exports = __webpack_public_path__ + "img/logo-lg.0ed99c15.png";